"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const index_1 = require("./index");
const reactstrap_1 = require("reactstrap");
exports.OsmosysButtonAddon = (_a) => {
    var { addonType = 'prepend' } = _a, props = tslib_1.__rest(_a, ["addonType"]);
    return (react_1.default.createElement(reactstrap_1.InputGroupAddon, { addonType: addonType },
        react_1.default.createElement(index_1.OsmosysButton, Object.assign({ osysName: "OsmosysButtonAddon", flexColCenteredTooltip: true, style: addonType === 'append'
                ? Object.assign({ borderBottomLeftRadius: 0, borderTopLeftRadius: 0 }, props.style) : Object.assign({ borderBottomRightRadius: 0, borderTopRightRadius: 0 }, props.style) }, props, { className: [
                props.className,
                'flex-grow-1',
                'border-addon',
                'border-top',
                'border-bottom',
                addonType === 'append' ? 'border-right' : 'border-left',
            ] }))));
};
//# sourceMappingURL=Addon.js.map